import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BlogCard from "./BlogCard";
import Loader from "../../animation/Loader.json";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import Lottie from "lottie-react";
import { formatDate, scrollToTop } from "../../constent/helper";

const AllBlogs = ({
  setOpen,
  blogs,
  latestArticles,
  loading,
  totalPages,
  fetchNextBlogs,
}) => {
  const { userInfo } = useSelector((state) => state?.authSlice);
  const theme = "light";
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const renderPagination = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <span
          key={i}
          onClick={() => handlePageChange(i)}
          className={`h-[6px] !w-[40px] rounded-sm transition-all duration-300 ${
            i === currentPage ? "bg-[#0EA5A4]" : "bg-[#C4C4C4]"
          }`}
        ></span>
      );
    }
  
    return (
      <div className="flex items-center justify-center gap-3 mt-4">
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Prev
          </button>
        )}
  
        <div className="flex items-center gap-3">{pages}</div>
  
        {currentPage < totalPages && (
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Next
          </button>
        )}
      </div>
    );
  };
  

  const handlePageChange = (page, event) => {
    setCurrentPage(page);
    const offset = (page - 1) * 10;
    fetchNextBlogs(offset);
    // Fetch users for the selected page using offset
    // Example: fetchUsers(offset, usersPerPage);
  };

  const handleRead = (blog) => {
    if (blog?.tags?.blog_url) {
      navigate(`/blog-details/${blog?.tags?.blog_url}?blogId=${blog?.id}`, {
        state: {
          blog,
          blogs,
          latestArticles,
          totalPages,
          currentPage,
        },
      });
    } else {
      navigate(`/blog-details/${blog?.id}?blogId=${blog?.id}`, {
        state: {
          blog,
          blogs,
          latestArticles,
          totalPages,
          currentPage,
        },
      });
    }
    scrollToTop()
  };


  return (
    <div>
      <div className=" min-h-[50vh]">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-10 min-h-[40vh]">
            <Lottie animationData={Loader} className="w-24 h-24" />
            <p className="text-gray-500 mt-3">Loading blogs...</p>
          </div>
        ) : (
          <div className=" w-full">

              <div className=" w-full bg-[#FFFFFF]">
                {/* Featured Blog */}
                {latestArticles[0] && (
                  <div className="w-full flex items-center justify-between md:flex-row flex-col sm:gap-10 gap-6 md:px-8 lg:px-12 px-[16px] md:py-16 py-8 max-w-screen-xl mx-auto">
                    {latestArticles[0]?.attachments?.[0]?.file && (
                      <div className="flex items-start justify-center md:w-1/2 w-full">
                        <img
                          src={latestArticles[0].attachments?.[0].file}
                          alt="cover image"
                          className="max-w-[500px] max-h-[370px] object-cover cursor-pointer w-full"
                          onClick={() => handleRead(latestArticles[0])}
                        />
                      </div>
                    )}
                    <div className="md:w-1/2 w-full grid grid-cols-1 justify-between">
                      <div>
                        <div className=" font-normal text-gary-600 my-4 flex gap-2 items-center text-base">
                          <span className="py-2 px-4 rounded-full flex items-center gap-2 border border-gray-400 capitalize">
                            <span className="w-2 h-2 rounded-full bg-primary-green " />
                            {latestArticles[0]?.tags?.keywords?.[0]}
                          </span>

                          {formatDate(latestArticles[0]?.created_at)}
                        </div>
                        <h2
                          className="font-bold text-xl cursor-pointer"
                          onClick={() => handleRead(latestArticles[0])}
                        >
                          {latestArticles[0]?.title}
                        </h2>
                        {latestArticles[0]?.description && (
                          <p className="my-2">
                            {latestArticles[0]?.tags?.meta_description}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-end">
                        <span className="text-primary-green font-medium text-base cursor-pointer flex items-center gap-1" onClick={()=>handleRead(latestArticles[0])}>
                          Read full <FaArrowRight />
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            <div className="max-w-screen-xl px-[16px] md:px-8 lg:px-12 mx-auto py-6 ">

              <div className="grid md:grid-cols-2 lg:grid-cols-3  grid-cols-1 gap-8">
                {blogs?.map((blog, i) => (
                  <div key={i} className="blogCard h-full">
                    <BlogCard blog={blog} />
                  </div>
                ))}
              </div>
              <div className="w-full mt-4 justify-center flex  items-center fontPoppins ">
                {renderPagination()}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllBlogs;
